/**
 * Art canvas size. Every room is authored at these dimensions and letterboxed
 * into the viewport, so background images should be 960x540 (or 1920x1080 for 2x).
 */
export const WORLD = { width: 960, height: 540 };
/** Avatar walk speed, world units per second. Server-authoritative. */
export const WALK_SPEED = 130;
/** Server simulation ticks per second. */
export const TICK_RATE = 20;
/** State patches sent to clients per second. Lower than TICK_RATE to save bandwidth. */
export const PATCH_RATE = 15;
export const MAX_CHAT_LENGTH = 120;
/** Chat rate limit: at most this many messages per CHAT_WINDOW_MS, per client. */
export const CHAT_BURST = 4;
export const CHAT_WINDOW_MS = 3000;
/**
 * Tope de gestos: como el del chat, pero más holgado y por una razón distinta.
 *
 * El del chat protege a los demás de que les inunden el registro. Éste protege al
 * SERVIDOR: un gesto no escribe nada ni sale en ningún log, sólo toca un campo del
 * estado, así que lo único que hay que acotar es el goteo de patches que produce
 * alguien machacando el botón.
 */
export const GESTURE_BURST = 6;
export const GESTURE_WINDOW_MS = 5000;
export const MAX_NICKNAME_LENGTH = 16;
/**
 * Largo de la descripción del carnet.
 *
 * Corta a propósito. Es una línea para decir quién eres —"de Guayaquil, juego vóley"—
 * y no un espacio de perfil: en un carnet, un párrafo empuja fuera de la tarjeta todo
 * lo que sí es del carnet. Y siendo la única casilla de texto libre que se enseña a
 * desconocidos, cuanto más corta, menos sirve para pegar un enlace o un anuncio.
 */
export const MAX_BIO_LENGTH = 140;
/**
 * Body colours. The index is what travels over the wire, so append rather than
 * reorder — an existing player's colour is stored as a position in this list.
 *
 * With sprite art these become tints, which means the body sprite must be drawn
 * in white/greyscale for tinting to look right. See docs/ART.md.
 */
/**
 * El ANCHO del jugador contra los muebles, en unidades de mundo.
 *
 * La colisión trataba al jugador como un punto —sus pies— así que podía arrimarse
 * hasta que su cuerpo se metía dentro del dibujo de un mueble: los pies fuera, el
 * caparazón dentro del escritorio. Con un ancho, lo que no cabe es el jugador, no su
 * punto de apoyo.
 *
 * 12 sale del dibujo: el avatar mide 52 de alto, su lienzo 512, y el contenido de
 * `s.png` ocupa 234 px de ancho — 234 × (52/512) = 23.8 de ancho en el mundo, o sea
 * 11.9 de medio ancho. Se redondea hacia arriba.
 *
 * Se mide SÓLO contra los muebles, no contra el borde de la sala. Aplicarlo también
 * a las paredes encogería cada piso 12 unidades por todos lados, y con él spawns,
 * umbrales y pasillos que hoy están ajustados — un cambio de mapa disfrazado de
 * cambio de colisión.
 */
export const PLAYER_RADIUS = 12;
export const AVATAR_COLORS = [
    0x1e6fd9, // blue
    0xd93b3b, // red
    0x36a852, // green
    0xe0b422, // yellow
    0xa855c7, // purple
    0xef8ab8, // pink
    0x18b6c4, // aqua
    0x2f3640, // black
];
//# sourceMappingURL=constants.js.map